export const metersToInches = (meters: number): number => meters * 39.370079;
